<template>
    <div>
        <b-card no-body v-show="mostrarTabela">
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>INTEGRAÇÃO ME EVENTOS</span>
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="obterItens(filtro)"
                            ></i>
                        </span>
                    </div>
                </h4>
                <b-alert :show="erro !== null" variant="danger">
                    {{ erro }}
                </b-alert>
                <filtros
                    @pesquisar="pesquisar($event)"
                    @erro="exibirErro($event)"
                ></filtros>
                <app-tabela
                    idTabela="tblIntegracaoMeEventos"
                    :itens="itens"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                    :filtrarAoDigitar="false"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <b-button
                                variant="success"
                                v-if="$temAcessoView('CONT-INT-ME-01')"
                                @click.stop="toIntegrarItens()"
                                ><i class="fa fa-plus"></i> Integrar
                                Itens</b-button
                            >
                        </b-button-group>
                    </template>
                    <template slot="statusIntegracao" slot-scope="data">
                        <b-badge
                            class="badge-status-integracao"
                            :variant="data.variantStatusIntegracao"
                            >{{ data.statusIntegracao }}</b-badge
                        >
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view @obterItens="obterItens(filtro)"></router-view>
    </div>
</template>

<script>
import MeEventosServicos from './MeEventosServicos'
import Filtros from './Filtros.vue'
import { obterStatusIntegracao } from './StatusIntegracao'

export default {
    data() {
        return {
            filtro: null,
            erro: null,
            temporizadorErro: null,
            itens: [],
            campos: [
                {
                    key: 'codigoContrato',
                    label: 'Número do Contrato',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap'
                },
                {
                    key: 'descricaoItem',
                    label: 'Descrição do Item',
                    filterable: true,
                    thStyle: { width: '100%' }
                },
                {
                    key: 'statusIntegracao',
                    label: 'Status da Integração',
                    sortable: true,
                    filterable: true,
                    type: 'status',
                    tdClass: 'text-nowrap text-center',
                    thClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 10
        }
    },

    components: {
        Filtros
    },

    methods: {
        obterItens(filtro) {
            this.$store.dispatch('addRequest')
            MeEventosServicos.obterItens(filtro).then((response) => {
                if (response) {
                    if (response.success) {
                        this.erro = null
                        this.itens = (response.data || []).map((item) => {
                            let status = obterStatusIntegracao(
                                item.statusIntegracao
                            )
                            return {
                                codigoContrato: item.codigoContrato,
                                descricaoItem: item.descricaoItem,
                                statusIntegracao: status.descricao,
                                variantStatusIntegracao: status.variant
                            }
                        })
                    } else {
                        this.exibirErro(response.mensagem)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        exibirErro(mensagem) {
            this.erro = mensagem
            clearTimeout(this.temporizadorErro)
            this.temporizadorErro = setTimeout(() => {
                this.erro = null
            }, 10000)
        },

        pesquisar(filtro) {
            this.filtro = filtro
            this.obterItens(filtro)
        },

        toIntegrarItens() {
            this.$router.push({
                name: 'Integracoes_MeEventos_Integrar'
            })
        }
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'Integracoes_MeEventos'
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'Integracoes_MeEventos') {
                if (this.$store.getters.recarregar) {
                    this.obterItens(this.filtro)
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    },

    created() {
        this.obterItens()
    },

    beforeDestroy() {
        clearTimeout(this.temporizadorErro)
    }
}
</script>

<style scoped>
.badge-status-integracao {
    font-size: 95%;
    padding: 0.5em 0.9em;
    white-space: nowrap;
}
</style>
